module.exports = __webpack_public_path__ + "assets/img/8.7ddf89da.png";